module.exports = __webpack_public_path__ + "static/media/arrow_down.fb622230.svg";